module.exports = __webpack_public_path__ + "img/auth.919d4925.jpg";